module.exports = __webpack_public_path__ + "img/Porto Apartment - 52 of 85.6b4ca2b3.jpeg";